var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.86,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.145.004H1.717A1.716 1.716 0 000 1.718v3.756h39.86v-3.76a1.714 1.714 0 00-1.715-1.71zM0 28.29a1.716 1.716 0 001.717 1.714h36.428a1.715 1.715 0 001.715-1.714V10.614H0zm20.086-10.286h11.688a.761.761 0 010 1.5H20.086a.761.761 0 010-1.5zm.266 3.43h16.516a.763.763 0 110 1.5H20.352a.763.763 0 110-1.5zM2.841 14.577h13.717a.75.75 0 010 1.5H2.84a.75.75 0 010-1.5zm0 3.427h13.717a.751.751 0 010 1.5H2.84a.751.751 0 010-1.5zm0 3.43h13.717a.75.75 0 010 1.5H2.84a.75.75 0 010-1.5z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccess);
export default __webpack_public_path__ + "static/media/access.91a4d7cef85101a953372c991e03f1b7.svg";
export { ForwardRef as ReactComponent };